import React, { memo, useEffect } from "react";
import { validators } from "investira.sdk";
import { Stack, Typography } from "investira.react.components";
import { Loading } from "../../components/molecules";
import BenchmarkListItem from "./BenchmarkListItem";

const BenchmarkList = memo((props) => {
  const { benchmarks = [], onDelete, isLoading } = props;

  const handleDelete = (pEvent, pBenchmark) => {
    pEvent.preventDefault();
    pEvent.stopPropagation();

    onDelete && onDelete(pBenchmark.benchmark_id);
  };

  if (isLoading) {
    return <Loading size={24} />;
  }

  return (
    <Stack>
      {benchmarks.length >= 1 && (
        <Stack>
          <Typography color="textSecondary" variant="caption">
            Meus Benchmarks
          </Typography>
        </Stack>
      )}
      {benchmarks
        .sort((a, b) => b.ativo_id - a.ativo_id)
        .map((xBenchmark) => {
          return (
            <BenchmarkListItem
              key={xBenchmark.indicador_id}
              benchmark={xBenchmark}
              onClick={(e) => {
                handleDelete(e, xBenchmark);
              }}
            />
          );
        })}
    </Stack>
  );
});

export default BenchmarkList;
